const products = [
    {
        id: "1",
        img: "/Images/Ourteam/team/6.jpg",
        Mname:"MAMTA KANYAL",
        designation:"Senior Manager Projects & Operations",
        
    },
    {
        id: "2",
        img: "/Images/Ourteam/team/21.jpg",
        Mname:"AVNISH MISHRA",
        designation:"Project Manager"
    },
    {
        id: "3",
        img: "/Images/Ourteam/team/30.jpg",
        Mname:"JAI KISHAN KUMAR",
        designation:"Project Coach"
    },
    {
        id: "4",
        img: "/Images/Ourteam/team/23.jpg",
        Mname:"VINOD KUMAR",
        designation:"Software Engineering Manager"
    },
    {
        id: "5",
        img: "/Images/Ourteam/team/27.jpg",
        Mname:"KANISHKA AGARWAL",
        designation:"Social Media Manager"
    }

]

export default products